import React from "react";
import "./PremiumRibbon.css";

const PremiumRibbon = ({ text = "Premium" }) => {
  return <div className="premium-ribbon">{text}</div>;
};

export default PremiumRibbon;
